import { toast } from 'sonner';
import { getEquipmentFileUrl } from './api';

/**
 * Open a private document in a new tab. The tab is opened synchronously (popup
 * blockers) and pointed at the short-lived signed URL once it arrives.
 */
export async function openEquipmentFile(kind: 'documents' | 'photos', id: string) {
  const tab = window.open('about:blank', '_blank');
  try {
    const url = await getEquipmentFileUrl(kind, id);
    if (tab) {
      tab.opener = null;
      tab.location.href = url;
    } else {
      window.location.assign(url);
    }
  } catch (error) {
    tab?.close();
    toast.error('Could not open the file', { description: error instanceof Error ? error.message : undefined });
  }
}
